import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Footer } from './Footer';
import { LiveVideoBar } from './LiveVideoBar';
import { BrandLogo } from './Logo';

// Per-route accent hue for the atmospheric background (no stock images —
// the backgrounds are pure CSS/SVG music atmospherics defined in styles.css).
const PAGE_HUE: Record<string, string> = {
  '/app': 'dashboard',
  '/app/studio': 'studio',
  '/app/library': 'library',
  '/app/wave': 'wave',
  '/app/arena': 'arena',
  '/app/battle-rules': 'arena',
  '/app/collabs': 'collabs',
  '/app/messages': 'messages',
  '/app/live': 'arena',
  '/app/tiers': 'tiers',
  '/app/safety': 'safety',
  '/app/admin': 'admin',
  '/app/notifications': 'dashboard',
  '/app/profile': 'studio',
};

export function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { pathname } = useLocation();

  const hue = PAGE_HUE[pathname] ?? 'dashboard';

  return (
    <div className="shell">
      {/* Fixed full-page atmospheric background (CSS/SVG, no images) */}
      <div className="page-bg" data-page={hue} aria-hidden="true" />

      {/* Mobile top bar (hidden on desktop) */}
      <div className="mobile-bar">
        <button
          className="icon-btn"
          aria-label="Toggle menu"
          onClick={() => setSidebarOpen((v) => !v)}
        >
          ☰
        </button>
        <BrandLogo height={30} />
      </div>

      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="main">
        <LiveVideoBar />
        <Header />
        <main className="content">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}
